import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationState } from './notifications.reducer';

export const notificationStateKey = 'notification';

export const selectNotificationState = createFeatureSelector(notificationStateKey);

export const selectNotifications = createSelector(
  selectNotificationState,
  (notificationState: NotificationState) => notificationState.notifications,
);
